import { useEffect, useRef, useState } from 'react'
import './levels-landing.styles.scss';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import LevelsList from './levels-list.component';
import LevelsForm from './levels-form.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import { useSelector } from 'react-redux';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import { properCase } from '@/utils/properCase';
import { getQueryFromFirestore } from '@/utils/getDataFromDbSimplified';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';
import { useEffectiveMembership } from '@/utils/useEffectiveMembership';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';

const LevelsLandingPage = ({
  gameData,
  gameElements,
  gameStats,
  role
}) => {

  const membership = useEffectiveMembership();
  const screenSize = useSelector(state => state.contentData.screenSize);
  const [showUpgradeModal, setShowUpgradeModal] = useState(null);
  const [levelsFromDb, setLevelsFromDb] = useState(null);
  const levelsRef = useRef();
  const location = useLocation();
  const levelsListenerRef = useRef();
  const navigate = useNavigate();

  const gameId = gameData?.gameId;
  const isPreview = location.pathname.includes('/preview/manager');

  useEffect(() => {

    changeDocumentTitle(`Levels | Manage ${gameData?.gameName}`, gameData?.icon);
  }, [gameData?.gameName])

  useEffect(() => {
    if (!membership || !gameData) return;
    checkMembership();
    function checkMembership() {
      const element = 'levels'
      const res = testMemberRestrictions({ 'gameData': gameData, 'membership': membership, 'element': element })

      if (res.disabled) {
        if (!membershipRestrictions) return;
        let message = ''
        const planRest = membershipRestrictions[membership.membership];
        if (res.disabledReason.includes(element)) {
          message = `While using the ${planRest.title}, you are not able to access ${properCase(element)}.`;
        }
        setShowUpgradeModal(message)
      }
    }
  }, [membership, gameData])

  useEffect(() => {
    if (!gameId) return;
    getGameElementsToManage();
    function getGameElementsToManage() {
      if (isPreview) {
        if (!completeGameElementData) return;
        const previewLevels = Object.values(completeGameElementData).filter(element => element.type === 'level');
        const levelsObj = {};
        previewLevels.forEach(level => {
          levelsObj[level.id] = level;
        });
        setLevelsFromDb(levelsObj);
        return;
      }
      getQueryFromFirestore({
        "path": `games/${gameId}/gameElements`,
        "queryArray": [{
          "field": "type",
          "operator": "==",
          "value": "level"
        }],
        "callback": callback,
        "handleListener": handleListener
      })
      function callback(data) {
        levelsRef.current = {
          ...levelsRef.current,
          ...{ [data.id]: data }
        }
        setLevelsFromDb(levelsRef.current);
      }
      function handleListener(data) {
        levelsListenerRef.current = data;
      }
    }

    return () => {
      if (levelsListenerRef.current) {
        levelsListenerRef.current();
        levelsListenerRef.current = null;
      }
    }
  }, [gameId, isPreview])

  return (
    <div className={`levels-landing ${screenSize}`}>
      <Routes>
        <Route path='' element={
          <div className='g-card levels-card'>
            <BackButton cancel={() => navigate(-1)} />
            <div className="g-space-1"></div>
            <div className='card-title'>
              <ImageContainer src='/images/icons/levels3.png' alt='levels icon' className='head-icon' />
              Create and Edit Levels
            </div>
            <hr />
            <div className='levels-landing-content'>
              <LevelsList
                gameElements={gameElements}
                levelsFromDb={levelsFromDb}
                gameData={gameData}
                role={role} />
            </div>
          </div>
        }></Route>
        <Route path='create' element={
          <LevelsForm
            gameElements={gameElements}
            levelsFromDb={levelsFromDb}
            gameData={gameData}
            gameStats={gameStats}
            role={role} />
        }></Route>
        <Route path='edit/:levelPath' element={
          <LevelsForm
            gameElements={gameElements}
            levelsFromDb={levelsFromDb}
            gameData={gameData}
            gameStats={gameStats}
            role={role} />
        }></Route>
        <Route path="*" element={<Navigate replace to="/404" />} />
      </Routes>
      <UpgradeRequiredModal
        show={showUpgradeModal}
        cancel={() => setShowUpgradeModal(null)}
        message={showUpgradeModal}
      />
    </div>
  )
}

export default LevelsLandingPage